import React from 'react';
import PropTypes from 'prop-types';
import Image from 'gatsby-image';

import SocialLinks from '../../SocialLinks';


const Hero = ({ title, header_image, subtitle, author, date, credits, slug, excerpt }) => (
  <div className="template__hero">
    <div className="template__hero-wrapper">
      <div className="template__hero-left">
        <div className="template__hero-date">{date}</div>

        <div className="template__hero-title">{title.text}</div>



        <div className="template__hero-credits"
          dangerouslySetInnerHTML={{ __html: credits.html }} />


        {console.log(excerpt)}
        <div className="template__share">
          <SocialLinks slug={slug} excerpt={excerpt} title={title} />

        </div>
      </div>

      <div className="template__hero-right">
        <div className="template__hero-image">
          <Image sizes={header_image.localFile.childImageSharp.sizes} />
        </div>
      </div>
    </div>
  </div>
);

Hero.defaultProps = {

};

Hero.propTypes = {
  /** Docgen prop description */

};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/CaseStudy/Hero/Hero.js